import { getValueFromStorage } from './useLocalSetting';

export default async function getLocalSetting<T>(code?: string,
                                                 initialState?: T): Promise<T>
{
    return getValueFromStorage(code, initialState);
}
